import styled from 'styled-components';

export const IconOption = styled.img`
  margin-right: 10px;
`;
